export default __webpack_public_path__ + "saha.04f2dddd.png";